import { useState } from "react";

type Periodo = {
  inicio: string;
  fim: string;
};

type FiltroPeriodoProps = {
  onChange?: (periodo: Periodo) => void;
};

export default function FiltroPeriodo({ onChange }: FiltroPeriodoProps) {
  const [inicio, setInicio] = useState<string>(
    () => new Date().toISOString().slice(0, 10) + "T00:00"
  );
  const [fim, setFim] = useState<string>(
    () => new Date().toISOString().slice(0, 10) + "T23:59"
  );

  const aplicar = () => onChange?.({ inicio, fim });

  return (
    <div className="flex flex-wrap items-end gap-2">
      <label className="flex flex-col text-xs">
        Início
        <input
          type="datetime-local"
          value={inicio}
          onChange={(e) => setInicio(e.target.value)}
          className="rounded-md border px-2 py-1"
        />
      </label>
      <label className="flex flex-col text-xs">
        Fim
        <input
          type="datetime-local"
          value={fim}
          onChange={(e) => setFim(e.target.value)}
          className="rounded-md border px-2 py-1"
        />
      </label>
      <button
        onClick={aplicar}
        className="px-3 py-1 rounded-md bg-slate-900 text-white"
      >
        Pesquisar
      </button>
    </div>
  );
}
